import React from 'react';
import './AddUserModal.css';

const AddUserModal = ({
  isOpen,
  onClose,
  onSubmit,
  newUser,
  handleInputChange,
  error,
  success
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal add-user-modal" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="modal-header">
          <h3>Add New User</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form className="add-user-form" onSubmit={onSubmit}>
          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}
          {success && (
            <div className="success-message">
              <i className="fas fa-check-circle"></i>
              {success}
            </div>
          )}
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={newUser.name}
              onChange={handleInputChange}
              placeholder="Enter Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={newUser.email}
              onChange={handleInputChange}
              placeholder="Enter Email"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={newUser.password}
              onChange={handleInputChange}
              placeholder="Enter secure password"
              required
            />
          </div>
          <div className="form-group">
            <label>User Role</label>
            <select
              name="role"
              value={newUser.role}
              onChange={handleInputChange}
              required
            >
              <option value="">Select role</option>
              <option value="User">User</option>
              <option value="Viewer">Viewer</option>
              <option value="Supervisor">Supervisor</option>
              <option value="Admin">Admin</option>
            </select>
          </div>
          <div className="form-group">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={newUser.location}
              onChange={handleInputChange}
              placeholder="Office location"
              required
            />
          </div>
          <div className="modal-footer">
            <button type="submit" className="submit-button">
              <i className="fas fa-user-plus"></i>
              Create Account
            </button>
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
